import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { A5StaticDatumsEdit } from "./edit";
import { A5StaticDataNew } from "./new";
import { A5StaticDatumsTable } from "./table";
export default function A5StaticDatums() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Actifs");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<A5StaticDatumsEdit />} />
      <Route index element={<A5StaticDatumsTable />} />
      <Route path="/new" element={<A5StaticDataNew />} />
    </Routes>
  );
}
